import { render, staticRenderFns } from "./SelectorSimilarTracks.vue?vue&type=template&id=794afaa4&scoped=true&"
import script from "./SelectorSimilarTracks.vue?vue&type=script&lang=js&"
export * from "./SelectorSimilarTracks.vue?vue&type=script&lang=js&"
import style0 from "./SelectorSimilarTracks.vue?vue&type=style&index=0&id=794afaa4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "794afaa4",
  null
  
)

export default component.exports